import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import cx from 'classnames';

import { Col, Container, Link, Row } from '@nord/ui';

import logoSvg from '../../assets/img/nord-layer-dark-logo.svg';
import BackButton, { IBackButtonProps } from '../../atoms/BackButton';
import SVG from '../../atoms/SVG';
import './WithImage.scss';

export interface IWithImageProps {
  backButton?: IBackButtonProps | boolean;
  leftPanel?: React.ReactNode;
  showLogo?: boolean;
  children?: React.ReactNode;
}

const WithImage: React.FC<IWithImageProps> = ({
  showLogo = false,
  backButton,
  leftPanel = <div />,
  children,
}) => {
  let backButtonRestProps = {};
  let backButtonClassNames = '';
  let backButtonWrapperClassName = '';

  const isButtonProps = (button?: IBackButtonProps | boolean): boolean =>
    typeof button === 'object';

  if (isButtonProps(backButton)) {
    const {
      className: btnClassNames = '',
      wrapperClassName: btnWrapperClassName = '',
      ...btnRestProps
    } = backButton as IBackButtonProps;

    backButtonRestProps = btnRestProps;
    backButtonClassNames = btnClassNames;
    backButtonWrapperClassName = btnWrapperClassName;
  }

  return (
    <Row gutter={false} className="min-h-screen relative TwoColViewContainer">
      {showLogo && (
        <div className="py-4 md:py-0 absolute z-1 top-0 left-0 flex justify-center w-full shadow-1 md:shadow-none">
          <Container fluid>
            <div className="lg:my-4 my-4">
              <Row justify="between" align="center">
                <Col lg={6} sm={8} xs={9} className="flex flex-no-wrap items-center justify-start">
                  <Link component={RouterLink} to="/" colorClassName="text-black">
                    <SVG
                      src={logoSvg}
                      title="NordLayer: Business VPN"
                      noDefaultSize
                      className="text-black ml-5"
                    />
                  </Link>
                </Col>
              </Row>
            </div>
          </Container>
        </div>
      )}
      {backButton && (
        <div
          className={cx('mt-6 pl-3 md:ml-5 absolute left-0 top-0 z-1', backButtonWrapperClassName)}
        >
          <BackButton
            {...backButtonRestProps}
            className={cx('pt-5 mt-4 md:pt-0 md:mt-0', backButtonClassNames)}
          />
        </div>
      )}
      <Col md={6} lg={7} className="hidden md:block bg-grey-lightest">
        <div className="h-screen flex flex-no-wrap items-center justify-center">{leftPanel}</div>
      </Col>
      <Col
        md={6}
        lg={5}
        className="bg-white shadow-1 md:flex block flex-no-wrap items-center justify-center"
      >
        <div className="flex justify-center w-full mb-7 md:mb-6 mt-7 md:mt-6">
          <Col sm={9}>{children}</Col>
        </div>
      </Col>
    </Row>
  );
};

export default WithImage;
